import React from 'react';
import styled from 'styled-components';

const HelpPopUp = ({closePopup}) => (
    <HelpContainer >
        <Title>How to Play "Sort It Out"</Title>

        <Section>
            <SectionTitle>Game Objective</SectionTitle>
            <Text>
                The goal of the game is to sort the randomly generated numbers from 1 to 10 into ascending order within 10 boxes.
            </Text>
        </Section>

        <Section>
            <SectionTitle>Game Rules</SectionTitle>
            <Text>
                - Numbers will be generated randomly. <br />
                - Drag and drop or click to place a number in the appropriate box. <br />
                - You lose if you cannot place a number while maintaining ascending order.
            </Text>
        </Section>

        <Section>
            <SectionTitle>Tips for Success</SectionTitle>
            <Text>
                - Always look ahead to see where you can place the next number. <br />
                - Remember the order of the numbers already placed to avoid mistakes. <br />
                - Practice makes perfect; keep trying to improve!
            </Text>
        </Section>

    </HelpContainer >
);

export default HelpPopUp;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Container = styled.div`
  background: linear-gradient(to bottom, #1a1a2e, #2d2d44, #4a4e69);
  width: 65vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 0px;
  border-radius: 20px;
  
  @media (max-width: 767px) {
    width: 80vw;
  }
`;
const HelpContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
    box-sizing:border-box;

  justify-content: center;
//   border-radius: 8px;
  height:100%;
  width:100%;
    padding: 0px 10px;

      background-color: ${({theme}) => theme.colors.background1};

`;

const Title = styled.h1`
  color: ${({theme}) => theme.colors.textColor1};
  font-size: 1.5rem;
  margin-bottom: 20px;
  font-family:text2;
`;

const Section = styled.div`
  width: 100%;
  margin: 10px 0px;
  box-sizing:border-box;
  padding: 0px 10px;
background-color: ${({theme}) => theme.colors.background2};
  border-radius: 6px;
//   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
`;

const SectionTitle = styled.h2`
  color: ${({theme}) => theme.colors.textColor1};
  font-size: 1.3rem;
  margin-bottom: 10px;
    font-family:text2;
`;

const Text = styled.p`
  color: ${({theme}) => theme.colors.textColor1};
  font-size: 0.9rem;
  line-height: 1.5;
    font-family:text2;
`;
